import 'babel-polyfill';
import { instance } from '../utils/axiosInstance'


export class BillingApi {
    static async getSalesPayroll() {
        return instance.get('/billing');
    }
    static async createSalesPerson(salespersonData){
        return instance.post('/billing', salespersonData)
    }
    static async updateSalesResources(salesPeopleId){
        return instance.put('/billing', salesPeopleId)
   
    }
}



// WEBPACK FOOTER //
// ./src/api/billing_api.js